const getContactFormStorageKey = (promotionSlug) => `contactFormSent_${promotionSlug}`;

export const hasContactFormBeenSent = (promotionSlug) => {
    return localStorage.getItem(getContactFormStorageKey(promotionSlug)) === 'true';
};

export const markContactFormAsSent = (promotionSlug) => {
    localStorage.setItem(getContactFormStorageKey(promotionSlug), 'true');
};
